/**
 * @generated SignedSource<<72295669dcf5e9195e4f5d1d88f082cc>>
 * @relayHash 2ef17314668b14dda538286710e09605
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 598b420ad313d1d5d7fca0e64b0c7300d57f2db81e8aa4b47edfac4fb0e1b42c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiAdminPagesFieldsQuery } from './uiAdminPagesFieldsQuery.graphql';

const node: PreloadableConcreteRequest<uiAdminPagesFieldsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "598b420ad313d1d5d7fca0e64b0c7300d57f2db81e8aa4b47edfac4fb0e1b42c",
    "metadata": {},
    "name": "uiAdminPagesFieldsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
